import { Component, OnInit, Input, EventEmitter, Output, ViewChild, QueryList } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from './loader.service';
import { LoaderState } from './loader';
import { NgProgress } from 'ngx-progressbar';

@Component({
    selector: 'loading-bar',
    templateUrl: 'loader.html'
})


export class LoaderComponent implements OnInit {
    public showOverlay: boolean = false;
    private subscription: Subscription;
    public type;

    public constructor(private loaderService: LoaderService, public ngProgress: NgProgress) {}

   
    ngOnInit() { 
        this.subscription = this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                if(state.show){
                    this.ngProgress.start();
                    
                }else{
                    this.ngProgress.done();
                }
                this.showOverlay = state.show;   
        });  
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./src/app/common/loadingBar/loader.component.ts